import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { Plus, Instagram } from "lucide-react";
import Countdown from "./Countdown";
import { BuyButton, LOOKUPS } from "../lib/checkout";
import { Reveal, MaskedInView } from "../lib/anim";
import { INSTAGRAM_URL } from "./chrome";

const INTIMACY_IMG = "https://images.unsplash.com/photo-1495581600346-93f223866d0a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHw0fHxlZGl0b3JpYWwlMjBmYXNoaW9uJTIwZGFyayUyMG1vb2R5JTIwc2lsaG91ZXR0ZXxlbnwwfHx8fDE3ODgxMjY2MzR8MA&ixlib=rb-4.1.0&q=85";

const FAQ_ITEMS = [
  {
    q: "WHAT IS PLEASURE PORTAL?",
    a: "Pleasure Portal is a botanical body ritual created around intentional touch, sensory awareness, presence and connection.",
  },
  {
    q: "WHO IS IT FOR?",
    a: "Pleasure Portal is designed for adults of any gender who want to create more intentional moments of sensory awareness, touch and connection.",
  },
  {
    q: "CAN COUPLES USE IT?",
    a: "The ritual can be incorporated into intentional moments between consenting adult partners according to the product's directions for use.",
  },
  {
    q: "HOW DO I USE IT?",
    a: "Spray directly onto the clitoris, inside the vagina or into the anus — or all of the above for the full triple-level experience. Then breathe, slow down, and come back to being fully present. Discontinue use if irritation occurs.",
  },
  {
    q: "WHAT IS IN PLEASURE PORTAL?",
    a: "The complete verified ingredient list will be displayed here once supplied.",
  },
  {
    q: "WHAT IS THE BUY 2 GET 1 FREE OFFER?",
    a: "Purchase two Pleasure Portal sprays for $222 and receive a third bottle free. You receive THREE bottles total for $222 instead of $381. That is a $159 savings. Plus, every order includes free access to our Tantra course inside Skool.",
  },
];

export function Offer() {
  return (
    <section id="offer" data-testid="offer-section" className="relative bg-[#050505] px-6 py-28 sm:py-44">
      <div className="pointer-events-none absolute inset-0" style={{ background: "radial-gradient(ellipse at 50% 0%, rgba(212,175,55,0.1), transparent 55%)" }} />
      <div className="relative mx-auto max-w-5xl">
        <h2 className="text-center ff-serif font-light leading-[0.95] text-[#fdfbf7]">
          <MaskedInView>
            <span className="block text-[12vw] sm:text-7xl">CHOOSE</span>
          </MaskedInView>
          <MaskedInView delay={0.15}>
            <span className="block text-[12vw] sm:text-7xl italic gold-text">YOUR PORTAL.</span>
          </MaskedInView>
        </h2>

        <Reveal delay={0.15}>
          <div className="glow-soft mx-auto mt-14 max-w-md overflow-hidden border hairline-gold">
            <img
              src="/images/triple-offer.jpg"
              alt="Pleasure Portal Buy 2 Get 1 Free — three bottles total for $222"
              loading="lazy"
              className="w-full object-cover"
              data-testid="offer-triple-image"
            />
          </div>
        </Reveal>

        <Countdown />

        <div className="mt-16 grid gap-8 md:grid-cols-2 md:gap-10">
          <Reveal delay={0.1}>
            <div data-testid="offer-single-card" className="flex h-full flex-col border hairline-champagne bg-white/[0.02] p-8 sm:p-10">
              <p className="text-[10px] uppercase tracking-[0.35em] text-[#f7e7ce]/50 ff-sans">Option 1</p>
              <p className="mt-4 ff-serif text-3xl font-light tracking-[0.05em] text-[#fdfbf7]">THE SOLO PORTAL</p>
              <p className="mt-2 text-[12px] uppercase tracking-[0.25em] text-[#f7e7ce]/60 ff-sans">1 Pleasure Portal Spray</p>
              <div className="mt-8 flex items-baseline gap-4">
                <p className="ff-serif text-6xl font-light text-[#fdfbf7]" data-testid="offer-single-price">$97</p>
                <p className="ff-serif text-2xl font-light text-[#f7e7ce]/35 line-through">$127</p>
              </div>
              <p className="mt-2 text-[10px] uppercase tracking-[0.3em] ff-sans" style={{ color: "#ff7fbf" }}>
                Limited-time introductory price
              </p>
              <div className="mt-auto pt-10">
                <BuyButton testid="offer-buy-single-btn" lookupKey={LOOKUPS.single} outline className="w-full">
                  Get One — $97
                </BuyButton>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.22}>
            <div data-testid="offer-triple-card" className="glow-border glow-soft relative flex h-full flex-col p-8 sm:p-10">
              <p className="text-center text-[10px] uppercase tracking-[0.35em] gold-text ff-sans font-semibold">★ Best Value ★</p>
              <p className="mt-4 text-center ff-serif text-3xl font-light tracking-[0.05em] text-[#fdfbf7]">THE TRIPLE PORTAL</p>
              <p className="mt-3 text-center ff-serif text-2xl font-light italic gold-text">Buy 2. Get 1 Free.</p>
              <div className="mt-8 text-center">
                <p className="text-[12px] uppercase tracking-[0.25em] text-[#f7e7ce]/60 ff-sans">You receive</p>
                <p className="mt-1 text-sm tracking-[0.15em] text-[#f7e7ce]/85 ff-sans">3 Pleasure Portal Sprays</p>
                <p className="mt-6 ff-serif text-7xl font-light gold-text" data-testid="offer-triple-price">$222</p>
                <p className="mt-2 text-[11px] uppercase tracking-[0.25em] text-[#f7e7ce]/50 ff-sans">
                  Regular value <span className="line-through">$381</span> — <span style={{ color: "#ff7fbf" }}>Save $159</span>
                </p>
              </div>
              <div className="mt-auto pt-10">
                <BuyButton testid="offer-buy-triple-btn" lookupKey={LOOKUPS.triple} className="w-full">
                  Get 3 for $222
                </BuyButton>
              </div>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.2} className="mt-14 text-center">
          <p className="ff-serif text-2xl sm:text-3xl font-light text-[#f7e7ce]/75">
            Keep one. <span className="italic gold-text">Share one.</span> Gift one.
          </p>
          <p className="mt-3 text-[12px] font-light tracking-wide text-[#f7e7ce]/50 ff-sans">
            Or keep all three. We won't judge.
          </p>
          <a
            data-testid="offer-skool-link"
            href="https://www.skool.com/love-vortex-6983"
            target="_blank"
            rel="noopener noreferrer"
            className="mx-auto mt-8 inline-block border border-[#ff007f]/50 px-6 py-3 text-[10px] uppercase tracking-[0.3em] ff-sans transition-all duration-300 hover:bg-[#ff007f]/10"
            style={{ color: "#ff7fbf" }}
          >
            ★ Free Tantra course on Skool included with every order ★
          </a>
        </Reveal>
      </div>
    </section>
  );
}

export function Intimacy() {
  return (
    <section data-testid="intimacy-section" className="bg-[#050505] px-6 py-28 sm:py-40">
      <div className="mx-auto grid max-w-6xl items-center gap-12 lg:grid-cols-2 lg:gap-20">
        <Reveal className="relative">
          <div className="overflow-hidden border hairline-gold">
            <img
              src="/images/bottle.jpg"
              alt="Close crop of the Pleasure Portal label — a couple embraced beneath the golden moon"
              loading="lazy"
              className="h-[420px] w-full object-cover object-[50%_62%] sm:h-[540px] transition-transform duration-[2s] ease-out hover:scale-[1.03]"
              data-testid="intimacy-artwork"
            />
          </div>
          <div className="pointer-events-none absolute inset-0" style={{ background: "radial-gradient(ellipse at 50% 80%, rgba(212,175,55,0.15), transparent 60%)" }} />
        </Reveal>

        <div>
          <Reveal>
            <p className="text-[11px] uppercase tracking-[0.4em] text-[#f7e7ce]/50 ff-sans">Chapter 04 — The Invitation</p>
          </Reveal>
          <h2 className="mt-6 ff-serif font-light leading-[1] text-[#fdfbf7]">
            <MaskedInView delay={0.1}>
              <span className="block text-[9vw] sm:text-5xl">WHAT IF INTIMACY</span>
            </MaskedInView>
            <MaskedInView delay={0.2}>
              <span className="block text-[9vw] sm:text-5xl">WASN'T ABOUT</span>
            </MaskedInView>
            <MaskedInView delay={0.3}>
              <span className="block text-[9vw] sm:text-5xl italic gold-text">PERFORMANCE?</span>
            </MaskedInView>
          </h2>
          <div className="mt-10 space-y-1.5">
            {["No finish line.", "No perfect way.", "No rushing.", "No pressure to become somebody else."].map((l, i) => (
              <MaskedInView key={l} delay={0.05 + i * 0.07}>
                <span className="ff-serif block text-xl sm:text-2xl font-light text-[#f7e7ce]/60">{l}</span>
              </MaskedInView>
            ))}
          </div>
          <Reveal delay={0.15} className="mt-8">
            <p className="text-sm font-light leading-relaxed text-[#f7e7ce]/70 ff-sans">
              Just humans becoming more present.
            </p>
          </Reveal>
          <div className="mt-4 flex flex-wrap gap-x-5 gap-y-1">
            {["Listening.", "Breathing.", "Touching.", "Communicating.", "Feeling."].map((l, i) => (
              <MaskedInView key={l} delay={0.05 + i * 0.06}>
                <span className="ff-serif text-xl sm:text-2xl font-light text-[#f7e7ce]/80">{l}</span>
              </MaskedInView>
            ))}
          </div>
          <MaskedInView delay={0.2} className="mt-12">
            <span className="ff-serif block text-[10vw] sm:text-6xl font-light italic gold-text">THAT'S THE PORTAL.</span>
          </MaskedInView>
        </div>
      </div>
    </section>
  );
}

export function FAQ() {
  return (
    <section data-testid="faq-section" className="bg-[#050505] px-6 py-28 sm:py-40">
      <div className="mx-auto max-w-3xl">
        <h2 className="text-center ff-serif font-light leading-[0.98] text-[#fdfbf7]">
          <MaskedInView>
            <span className="block text-[9vw] sm:text-5xl">YOU HAVE QUESTIONS.</span>
          </MaskedInView>
          <MaskedInView delay={0.15}>
            <span className="block text-[9vw] sm:text-5xl italic gold-text">WE HAVE ANSWERS.</span>
          </MaskedInView>
        </h2>

        <Reveal delay={0.2} className="mt-14">
          <AccordionPrimitive.Root type="single" collapsible className="w-full">
            {FAQ_ITEMS.map((item, i) => (
              <AccordionPrimitive.Item
                key={item.q}
                value={`faq-${i}`}
                data-testid={`faq-item-${i + 1}`}
                className="border-b hairline-champagne"
              >
                <AccordionPrimitive.Header>
                  <AccordionPrimitive.Trigger
                    data-testid={`faq-trigger-${i + 1}`}
                    className="group flex w-full items-center justify-between gap-6 py-6 text-left ff-serif text-lg sm:text-xl font-light tracking-[0.05em] text-[#fdfbf7] transition-colors duration-300 hover:text-[#d4af37]"
                  >
                    {item.q}
                    <Plus
                      size={16}
                      strokeWidth={1.25}
                      className="shrink-0 text-[#d4af37] transition-transform duration-500 group-data-[state=open]:rotate-45"
                    />
                  </AccordionPrimitive.Trigger>
                </AccordionPrimitive.Header>
                <AccordionPrimitive.Content
                  data-testid={`faq-content-${i + 1}`}
                  className="overflow-hidden text-sm font-light leading-relaxed text-[#f7e7ce]/70 ff-sans data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
                >
                  <p className="pb-6 pr-8">{item.a}</p>
                </AccordionPrimitive.Content>
              </AccordionPrimitive.Item>
            ))}
          </AccordionPrimitive.Root>
        </Reveal>
      </div>
    </section>
  );
}

export function Contact() {
  return (
    <section id="contact" data-testid="contact-section" className="bg-[#050505] px-6 py-24 sm:py-32">
      <Reveal>
        <div className="glow-border mx-auto max-w-2xl p-10 text-center sm:p-14">
          <Instagram size={20} strokeWidth={1.25} className="mx-auto text-[#d4af37]" />
          <h2 className="mt-6 ff-serif font-light leading-[0.95] text-[#fdfbf7]">
            <span className="block text-[10vw] sm:text-5xl">STILL HAVE</span>
            <span className="block text-[10vw] sm:text-5xl italic gold-text">QUESTIONS?</span>
          </h2>
          <p className="mt-6 text-sm font-light leading-relaxed text-[#f7e7ce]/70 ff-sans">
            Wondering if Pleasure Portal is right for you?
            <br />
            Have a question about the ritual, ordering or your purchase?
            <br />
            DM me directly on Instagram.
          </p>
          <a
            data-testid="instagram-dm-btn"
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="DM me on Instagram — opens in a new tab"
            className="btn-gold mt-8 inline-flex items-center gap-2 px-8 py-4 text-xs font-semibold uppercase tracking-[0.25em] ff-sans"
          >
            DM Me on Instagram →
          </a>
          <p className="mt-6 ff-script text-2xl text-[#f7e7ce]/70">I'd love to hear from you. ♡</p>
        </div>
      </Reveal>
    </section>
  );
}

export function FinalCTA() {
  return (
    <section data-testid="final-cta-section" className="relative overflow-hidden bg-[#050505] px-6 py-28 sm:py-44">
      <div className="pointer-events-none absolute inset-0" style={{ background: "radial-gradient(ellipse at 50% 45%, rgba(212,175,55,0.14), transparent 60%)" }} />
      <div className="relative mx-auto max-w-4xl text-center">
        <Reveal>
          <div className="glow-soft mx-auto w-48 overflow-hidden rounded-t-[999px] border hairline-gold sm:w-60">
            <img
              src="/images/bottle.jpg"
              alt="Pleasure Portal Spray bottle"
              loading="lazy"
              className="w-full object-cover"
              data-testid="final-cta-artwork"
            />
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-8 text-[11px] uppercase tracking-[0.4em] gold-text ff-sans font-medium">
            Pleasure • Presence • Connection
          </p>
        </Reveal>
        <h2 className="mt-6 ff-serif font-light leading-[0.92] text-[#fdfbf7]">
          <MaskedInView delay={0.1}>
            <span className="block text-[14vw] sm:text-8xl">THE PORTAL</span>
          </MaskedInView>
          <MaskedInView delay={0.25}>
            <span className="block text-[14vw] sm:text-8xl italic gold-text">IS OPEN.</span>
          </MaskedInView>
        </h2>

        <div className="mx-auto mt-14 grid max-w-2xl gap-4 sm:grid-cols-2">
          <Reveal delay={0.15}>
            <div className="border hairline-champagne bg-black/50 p-6">
              <p className="text-[10px] uppercase tracking-[0.3em] text-[#f7e7ce]/60 ff-sans">One Spray</p>
              <p className="mt-2 ff-serif text-4xl font-light text-[#fdfbf7]" data-testid="final-single-price">
                $97 <span className="text-xl text-[#f7e7ce]/35 line-through">$127</span>
              </p>
              <p className="mt-1 text-[9px] uppercase tracking-[0.25em] ff-sans" style={{ color: "#ff7fbf" }}>Limited time</p>
              <BuyButton testid="final-buy-single-btn" lookupKey={LOOKUPS.single} outline className="mt-5 w-full">
                Enter the Portal — $97
              </BuyButton>
            </div>
          </Reveal>
          <Reveal delay={0.25}>
            <div className="glow-border bg-black/50 p-6">
              <p className="text-[10px] uppercase tracking-[0.3em] gold-text ff-sans font-semibold">★ Best Value ★ Buy 2 • Get 1 Free</p>
              <p className="mt-2 ff-serif text-4xl font-light gold-text" data-testid="final-triple-price">
                3 Sprays — $222
              </p>
              <p className="mt-1 text-[10px] uppercase tracking-[0.25em] ff-sans" style={{ color: "#ff7fbf" }}>Save $159</p>
              <BuyButton testid="final-buy-triple-btn" lookupKey={LOOKUPS.triple} className="mt-5 w-full">
                Get 3 — $222
              </BuyButton>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.2}>
          <div className="glow-border glow-soft mx-auto mt-14 max-w-md overflow-hidden">
            <img
              src="/images/promo-new.jpg"
              alt="Pleasure Portal Buy 2 Get 1 Free — 3 bottles total for $222, just $74 each"
              loading="lazy"
              className="w-full object-cover"
              data-testid="final-cta-promo-image"
            />
          </div>
        </Reveal>

        <div className="mt-20">
          <MaskedInView delay={0.1}>
            <span className="ff-serif block text-2xl sm:text-4xl font-light text-[#f7e7ce]/70">
              STOP RUSHING THROUGH YOUR BODY.
            </span>
          </MaskedInView>
          <MaskedInView delay={0.25}>
            <span className="ff-script mt-4 block text-4xl sm:text-5xl gold-text">come back to it.</span>
          </MaskedInView>
        </div>
      </div>
    </section>
  );
}
